import styled from "styled-components";
import { breakpoints, Font, Color } from "@/shared/Constants";

export const Error404Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .error-title-container {
    width: 90%;
    border-bottom: 1px solid ${Color.greySeparator};
    padding-bottom: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    ${breakpoints.phone} {
        padding-bottom: 40px; 
    }
    .error-img {
      width: 101px;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 35px;
      margin-top: 35px;
      img {
        width: 100%;
        max-width: 100%;
      }
      ${breakpoints.phone} {
        width: 62px;
        height: 54px;
        margin-bottom: 20px;
        margin-top: 20px;
      }
    }
    .error-title {
      
      font-size: 30px;
      line-height: 48px;
      color: ${Color.grey};
      text-align: center;
      ${breakpoints.phone} {
        font-size: 22px;
        line-height: 27px;
      }
      span {
        font-size: 72px;
        padding-bottom: 20px;
        display: block;
        ${breakpoints.phone} {
          font-size: 38px;
          padding-bottom: 15px;
        }
      }
    }
  }
  .error-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 55px;
    ${breakpoints.phone} {
        padding: 40px 20px 0px;
    }
    .error-text {
      
      font-size: 22px;
      line-height: 36px;
      color: ${Color.grey};
      &:first-of-type {
        padding-bottom: 25px;
      }
      ${breakpoints.phone} {
        font-size: 18px;
        line-height: 26px;
        text-align: center;
      }
    }
    .error-list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .error-list-item {
     
        font-size: 22px;
        line-height: 36px;
        color: ${Color.grey};
        ${breakpoints.phone} {
          font-size: 18px;
          line-height: 26px;
        }
        .error-arrow{
            width: 14px;
        }
      }
    }
    .error-link {
      display: inline;
      color: ${Color.mainColor};
      text-decoration: underline;
      &:visited {
        color: ${Color.mainColor};
      }
    }
  }
`;
